export default "__VITE_ASSET__CDNgDs1N__"